<template>
  <q-form ref="form" class="full-width q-pa-md">
    <div class="row items-center">
      <div class="col-12 q-pa-sm">
        <q-card q-card flat bordered>
          <q-card-section>
            <div class="row">
              <div class="col-12 q-pa-xs">
                <autocomplete
                  label="Filter By Division"
                  :items="divisions.filter(d => divisionKeys[d.id])"
                  :itemsLoading="divisionsLoading || eventsLoading"
                  option_label="division_name"
                  option_value="id"
                  :id="memberFilter.division"
                  @changed="
                    val => {
                      memberFilter.division = val;
                      filterMembers();
                    }
                  "
                  clearable
                />
              </div>
            </div>
            <div class="row">
              <div
                v-if="$route.name != 'competitionsView'"
                class="col-12 col-md-6 q-px-xs"
              >
                <assignAssociation
                  :id="association_id"
                  :customData="competitionAssociations"
                  @changed="val => (association_id = val)"
                />
              </div>
              <div class="col q-px-xs">
                <assignMember
                  :id="formData.associationsMembers_id"
                  label="Association Member Lookup"
                  :specificMembers="filteredAthletes"
                  :readonly="formData.id ? true : false"
                  :excludeIDList="[]"
                  @changed="updateMember"
                />
              </div>
              <div class="col-12">
                <q-btn
                  class="full-width bg-primary text-white"
                  label="Scan Athlete NFC"
                  @click="scanAthlete()"
                >
                </q-btn>
              </div>
            </div>
          </q-card-section>
          <q-separator v-if="memberDetails" />
          <q-card-section v-if="memberDetails">
            <div class="row">
              <div class="col-12">Member Details</div>
            </div>
            <div class="row justify-between">
              <div class="col-auto text-center q-my-sm">
                <q-icon name="mdi-account" size="sm"></q-icon>
                {{ memberDetails.firstName }} {{ memberDetails.lastName }}
              </div>
              <div class="col-auto text-center q-my-sm" style="">
                <q-icon name="mdi-phone" size="sm"></q-icon>
                {{ memberDetails.mobilePhone }}
              </div>
              <div class="col-auto text-center q-my-sm">
                <q-icon name="mdi-calendar" size="sm"></q-icon>
                {{ memberDetails.birthDate }}
              </div>
              <div class="col-auto text-center q-my-sm">
                <b>Division</b>
                {{ athletesDivision }}
              </div>
              <div class="col-auto text-center q-my-sm">
                <q-icon name="mdi-gender-male-female " size="sm"></q-icon>
                {{ memberDetails.gender }}
              </div>
            </div>
          </q-card-section>
          <q-separator v-if="memberDetails" />

          <q-card-section v-if="memberDetails">
            <div class="row">
              <div class="col-12">Enter into an Event</div>
              <div class="col-md-10 col-12">
                <assignEvent
                  :id="formData.events_id"
                  label="Event"
                  :filterToMember="memberDetails"
                  :excludeEvents="excludedEvents"
                  :individualEventsOnly="true"
                  :readonly="formData.id ? true : false"
                  multiple
                  chips
                  @changed="selectNewEvent"
                />
              </div>
              <div class="col-12 col-md-2 q-pa-sm">
                <q-btn
                  color="primary"
                  no-caps
                  :disable="!formData.events_id"
                  class="float-right full-width"
                  :loading="enteringMemberLoading"
                  @click="enterMemberIntoEvent"
                >
                  Enter & Save
                </q-btn>
              </div>
            </div>
          </q-card-section>
        </q-card>
        <!-- TODO: Need to have it that if the member has already been entered that it loads that members data -->
      </div>
      <div class="col-12">
        <div class="row" v-if="memberDetails">
          <div class="col-12">Entered Events</div>
          <div class="col-12 text-negative" v-if="qualTimesNotEntered">
            If you have a qualification time for the athlete, please enter it
            below and confirm the entry, otherwise just confirm the entry
            (mm:ss:hs e.g. 02:20.78)
            <q-btn
              label="Confirm All"
              no-caps
              v-if="currentUserData.role != 'Official'"
              class="text-white bg-primary"
              :loading="confirmAllEventsLoading"
              @click="confirmAllEvents"
            ></q-btn>
          </div>
          <div
            v-for="(event, index) in membersCurrentEvents"
            :key="`currentEvent_${index}`"
            class="q-pa-sm eventCard"
            style="height: 100%"
          >
            <q-card style="width: 300px; height: 227px">
              <q-card-section
                style="height: calc(100% - 52px)"
                class="text-white"
                :class="{
                  'bg-primary':
                    !competition.qualifyingTimesOrMarks ||
                    event.status == 'Confirmed',
                  'bg-blue-grey':
                    competition.qualifyingTimesOrMarks &&
                    event.status != 'Confirmed'
                }"
              >
                <div class="text-h6">
                  {{ event.event_name.split(" - ")[1] }}
                </div>
                <div class="text-subtitle2">
                  {{ event.event_name.split(" - ")[0] }}
                </div>
                <div v-if="competition.qualifyingTimesOrMarks">
                  <q-input
                    :readonly="event.status == 'Confirmed'"
                    dense
                    dark
                    v-model="event.qualMark"
                    label="Qual Time"
                    color="white"
                    mask="##:##.##"
                    placeholder="mm:ss:hs"
                    v-bind="siteCFG.fields.general"
                    @change="saveEventEntry(event)"
                  >
                  </q-input>
                </div>
              </q-card-section>
              <q-separator />
              <q-card-actions
                align="right"
                v-if="
                  $route.path.includes('waves') ||
                    ($moment() < $moment(competition.entriesCloseDate) &&
                      event.currentStep == 0) ||
                    event.entriesOpenOverride ||
                    ['Admin', 'Sport Manager'].includes(currentUserData.role)
                "
              >
                <q-btn
                  v-if="events_id == event.events_id && fromWaves && round_id"
                  flat
                  no-caps
                  @click="enterMemberIntoEvent()"
                  style="position: absolute; left: 10px"
                >
                  Select
                </q-btn>
                <q-btn
                  flat
                  no-caps
                  v-if="event.status == 'Draft'"
                  @click="updateEntryStatus(event, 'Confirmed')"
                >
                  Confirm Entry
                </q-btn>
                <q-btn
                  flat
                  no-caps
                  v-else
                  @click="updateEntryStatus(event, 'Draft')"
                >
                  Edit
                </q-btn>
                <q-btn flat no-caps @click="removeFromEvent(event.id)">
                  Remove
                </q-btn>
              </q-card-actions>
            </q-card>
          </div>
        </div>
      </div>
    </div>
  </q-form>
</template>

<script>
import { mapGetters } from "vuex";
import assignMember from "@/components/users/assignMember.vue";
import assignEvent from "@/components/events/assignEvent.vue";
import moment from "moment";
import assignAssociation from "@/components/associations/assignAssociation.vue";
import autocomplete from "@/components/wrappers/autocomplete/autocomplete.vue";
import { NFCScan, NFCWrite } from "@/plugins/NFC";

export default {
  components: { assignMember, assignEvent, assignAssociation, autocomplete },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
      currentUserData: "auth/currentUserData",
      siteCFG: "settings/siteCFG",
      data: "associations/currentMember",
      dataLoading: "associations/currentMemberLoading",
      competition: "competitions/current",
      members: "associations/members",
      membersCurrentEvents: "associations/membersEnteredIndividualEvents",
      divisions: "divisions/list",
      divisionsLoading: "divisions/listLoading",
      association: "associations/current",
      competitionAssociations: "competitions/associationsList",
      competitionAssociationsLoading: "competitions/associationsListLoading",
      events: "events/listForCompetition",
      eventsLoading: "events/listForCompetitionLoading",
      currentWavesEvent: "events/current"
    }),
    excludedEvents: function() {
      let eventIds = this.membersCurrentEvents.map(mce => mce.events_id);

      this.events.forEach(event => {
        if (
          (moment(this.competition.entriesCloseDate) < moment() ||
            event.currentStep != 0) &&
          !event.entriesOpenOverride &&
          ["Admin", "Sports Manager"].includes(!this.currentUserData.role)
        ) {
          eventIds.push(event.id);
        }
      });

      return eventIds;
    },
    qualTimesNotEntered: function() {
      if (!this.competition.qualifyingTimesOrMarks) return false;
      let result = false;
      let events = JSON.parse(JSON.stringify(this.membersCurrentEvents));
      events.forEach((event, index, arr) => {
        if (!event.qualMark && event.status == "Draft") {
          result = true;
          arr.length = index + 1; // Breaks out of Loop
        }
      });

      return result;
    },
    athletesDivision: function() {
      if (this.divisions) {
        // let year = moment().format("YYYY");
        let reference = moment(this.competition.age_reference_date);
        // if (moment(`${year}-09-30`) > moment()) {
        //   reference = reference.subtract(1, "years");
        // }
        let age = reference.diff(this.memberDetails.birthDate, "years", false);
        // console.log(age);
        let div = this.divisions.find(
          d =>
            d.division_age_min <= age &&
            d.age_max >= age &&
            this.memberDetails.gender == d.gender
        );
        return div ? div.division_name : "No Division";
      } else {
        return "";
      }
    }
  },
  props: {
    id: {
      default: null
    },
    fromWaves: {
      type: Boolean,
      default: false
    },
    competitions_id: {
      type: Number,
      default: null
    },
    round_id: {
      type: Number,
      default: null
    },
    events_id: {
      type: Number,
      default: null
    }
  },
  watch: {
    data: function() {
      this.init();
    },
    id: function() {
      this.init();
    },
    association_id: function() {
      this.$store
        .dispatch("associations/loadByID", this.association_id)
        .then(async () => {
          await this.$store.dispatch("associations/loadMembersForAssociation", {
            id: this.association_id,
            competitions_id: this.competitions_id
          });

          this.init();
        });
    },
    members: function() {
      this.filterMembers();
    },
    events: function() {
      this.filterDivisionsByEvents();
    }
  },
  data: () => ({
    // Extra Data
    formData: {
      id: null,
      associationsMembers_id: null,
      events_id: []
    },
    memberDetails: null,

    enteringMemberLoading: false,

    removingFromEvent: false,

    association_id: null,

    memberFilter: {
      division: null
    },

    filteredAthletes: [],

    divisionKeys: {},

    confirmAllEventsLoading: false,

    // NFC
    nfcScanner: null,
    handleReading: null,
    scannedMemberID: null
  }),
  beforeCreate() {},
  mounted() {
    if (this.fromWaves) {
      // this.$store.dispatch("events/loadAssociations", this.id);
      this.$store.dispatch(
        "events/loadForCompetition",
        this.$route.params.competitions_id
      );
      this.$store.dispatch(
        "competitions/loadAssociations",
        this.$route.params.competitions_id
      );
    }
    this.init();
    this.filterDivisionsByEvents();
    if (this.fromWaves) {
      this.memberFilter.division = this.currentWavesEvent.division_id;
    }
  },
  methods: {
    filterDivisionsByEvents() {
      let divisionKeys = {};
      this.events.forEach(event => {
        if (!divisionKeys[event.division_id]) {
          divisionKeys[event.division_id] = true;
        }
      });

      this.divisionKeys = divisionKeys;
    },
    init() {
      this.filterMembers();
      if (this.id && !this.fromWaves) {
        this.updateMember(parseInt(this.id));
      } else if (!this.scannedMemberID) {
        this.formData = {
          id: null,
          associationsMembers_id: null,
          events_id: this.events_id ? [this.events_id] : []
        };
      }
    },
    updateMember(id) {
      this.formData.associationsMembers_id = id;

      this.memberDetails = this.members.find(m => m.id == id);

      this.$store.dispatch("associations/loadMembersEnteredIndividualEvents", {
        associationsMembers_id: id,
        competitions_id: this.fromWaves
          ? parseInt(this.$route.params.competitions_id)
          : parseInt(this.$route.params.id)
      });

      setTimeout(() => {
        this.formData.events_id = this.events_id
          ? [parseInt(this.events_id)]
          : [];
      }, 50);
    },
    selectNewEvent(id) {
      this.formData.events_id = id;
    },
    enterMemberIntoEvent() {
      this.enteringMemberLoading = true;

      let payload = {
        associationsMembers_id: this.formData.associationsMembers_id,
        associations_id: this.fromWaves ? this.association_id : null,
        events_id: this.formData.events_id,
        qualMark: this.formData.qualMark,
        round_id: this.round_id
      };

      this.$refs.form.validate().then(result => {
        if (result) {
          this.$store
            .dispatch("eventsEntries/enterIndividualIntoEvent", payload)
            .then(result => {
              this.enteringMemberLoading = false;
              this.formData.events_id = [];
              if (result.Result == "Success") {
                this.$emit("newTeamEntered");
                // this.$emit("close");
                this.$q.notify({
                  position: "top-right",
                  type: "positive",
                  message: result.Response.Message
                });
              } else {
                this.$q.notify({
                  position: "top-right",
                  type: "negative",
                  message: result.Response
                });
              }
              this.loadMembersData(this.formData.associationsMembers_id);
            });
        } else {
          this.enteringMemberLoading = false;
        }
      });
    },
    updateEntryStatus(event, status) {
      event.status = status;
      this.$store
        .dispatch("eventsEntries/saveIndividualEntry", event)
        .then(result => {
          if (result.Result == "Success") {
            this.$q.notify({
              position: "top-right",
              type: "positive",
              message: result.Response.Message
            });
          } else {
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message: "There was an Error, Please try again later"
            });
          }
          this.loadMembersData(this.formData.associationsMembers_id);
        });
    },
    removeFromEvent(id) {
      this.removingFromEvent = true;

      let payload = {
        id: id
      };

      this.$store
        .dispatch("eventsEntries/removeIndividualFromEvent", payload)
        .then(result => {
          this.removingFromEvent = false;
          if (result.Result == "Success") {
            this.$q.notify({
              position: "top-right",
              type: "positive",
              message: result.Response.Message
            });
          } else {
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message: "There was an Error, Please try again later"
            });
          }
          this.loadMembersData(this.formData.associationsMembers_id);
        });
    },

    loadMembersData(id) {
      this.$store.dispatch("associations/loadMembersEnteredIndividualEvents", {
        associationsMembers_id: id,
        competitions_id: this.competition.id
      });
      this.$store.dispatch(
        "eventsEntries/loadAllIndividualEntriesForCompetition",
        this.competition.id
      );
    },

    saveEventEntry(event) {
      this.$store
        .dispatch("eventsEntries/saveIndividualEntry", event)
        .then(result => {
          if (result.Result == "Success") {
            this.$q.notify({
              position: "top-right",
              type: "positive",
              message: result.Response.Message
            });
          } else {
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message: "There was an Error, Please try again later"
            });
          }
          this.loadMembersData(this.formData.associationsMembers_id);
        });
    },

    filterMembers() {
      let members = JSON.parse(JSON.stringify(this.members)).filter(member => {
        if (this.memberFilter.division) {
          let year = moment().format("YYYY");
          let reference = moment(`${year}-09-30`);
          if (moment(`${year}-07-01`) > moment()) {
            reference = reference.subtract(1, "years");
          }
          let age = reference.diff(member.birthDate, "years", false);
          // console.log(age);
          let div = this.divisions.find(
            d =>
              d.division_age_min <= age &&
              d.age_max >= age &&
              (member.gender == d.gender || d.gender == "X") &&
              d.id == this.memberFilter.division
          );

          if (!div || div.id != this.memberFilter.division) {
            return false;
          }
        }

        return member;
      });

      this.formData = {
        id: null,
        associationsMembers_id: null,
        events_id: this.events_id ? [this.events_id] : []
      };

      this.memberDetails = null;

      this.filteredAthletes = members;

      if (this.scannedMemberID) {
        console.log(this.filteredAthletes);
        let athlete = this.filteredAthletes.find(
          a => a.id == this.scannedMemberID
        );

        if (!athlete) {
          this.$q.notify({
            position: "top-right",
            type: "negative",
            message: "Member is not Eligible for this Event"
          });
          return;
        }
        this.updateMember(this.scannedMemberID);
      }
    },

    confirmAllEvents() {
      this.confirmAllEventsLoading = true;
      this.$store
        .dispatch("eventsEntries/confirmAllEntries", {
          associationsMembers_id: this.formData.associationsMembers_id,
          competitions_id: this.fromWaves
            ? this.$route.params.competitions_id
            : this.$route.params.id
        })
        .then(result => {
          this.confirmAllEventsLoading = false;

          if (result.Result == "Success") {
            this.$q.notify({
              position: "top-right",
              type: "positive",
              message: result.Response.Message
            });
          } else {
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message: "There was an Error, Please try again later"
            });
          }
          this.loadMembersData(this.formData.associationsMembers_id);
        });
    },

    // NFC
    async handleNFCScan(message, serialNumber, extraData) {
      this.nfcScanner.removeEventListener("reading", this.handleReading);

      // ADD NFC to Member
      try {
        let response = await this.$store.dispatch(
          "associations/loadMemberViaNFC",
          {
            serialNumber: serialNumber
          }
        );

        if (response.Result) {
          this.$q.notify({
            position: "top-right",
            type: "negative",
            message: response.Message
          });
          return;
        }

        // Check Member Meets Event Criteria
        let member = response[0];

        this.scannedMemberID = member.id;

        this.association_id = member.associations_id;

        this.$q.notify({
          position: "top-right",
          type: "positive",
          message: "Member Scanned Successfully"
        });
      } catch (error) {
        this.$q.notify({
          position: "top-right",
          type: "negative",
          message: "There was an error, Please try again later"
        });
      }
    },
    async scanAthlete() {
      try {
        this.nfcScanner.removeEventListener("reading", this.handleReading);
      } catch (error) {
        console.log(error);
      }
      console.log("Scanning NFC");

      const { ndef, handleReading } = await NFCScan(
        this,
        this.handleNFCScan,
        null
      );

      this.nfcScanner = ndef;
      this.handleReading = handleReading;
    }
  }
};
</script>

<style lang="scss" scoped>
.eventCard {
  min-width: 220px !important;
}
</style>
